export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/fixture.worker.8cfb7bd0.worker.js");
}
